export const incomeTaskTemplateNorway = [
   {
    Time: "08:30",
    Task: "Check for NOT acknowledged emails (from previous business day)",

    taskPrimary: { value: "", active: true },
    taskPrimaryCheck: { checked: false, timestamp: null, user: null },

    actions: {
      canAdd: false
    },
    allocationFields: {
      shortName: false,
      isin: false,
      corpRef: false,
      ack: false
    },
    Items: "",

    allocations: [
      {
        allocPrimary: { value: "", active: true },
        allocPrimaryCheck: { checked: false, timestamp: null, user: null },

        allocDuality: { value: "", active: true },
        allocDualityCheck: { checked: false, timestamp: null, user: null },

        shortName: { value: "", active: true },   
        isin:      { value: "", active: true },   
        corpRef:   { value: "", active: true },   
        ack:       { value: "", active: true }    
      }
    ],

    Comments: ""
  },
  {
    Time: "08:40",
    Task: "Check processed items by Dividend Robot for yesterday",

    taskPrimary: { value: "", active: true },
    taskPrimaryCheck: { checked: false, timestamp: null, user: null },

    actions: {
      canAdd: false
    },
    allocationFields: {
      shortName: false,
      isin: false,
      corpRef: false,
      ack: false
    },
    Items: "",

    allocations: [
      {
        allocPrimary: { value: "", active: true },
        allocPrimaryCheck: { checked: false, timestamp: null, user: null },

        allocDuality: { value: "", active: true },
        allocDualityCheck: { checked: false, timestamp: null, user: null },

        shortName: { value: "", active: false },   
        isin:      { value: "", active: false },   
        corpRef:   { value: "", active: false },   
        ack:       { value: "", active: false }    
      }
    ],

    Comments: ""
  },
     {
    Time: "10:20",
    Task: "Process manual interest payments (check Finess vs SEBIS) (DL 12:00)",

    taskPrimary: { value: "", active: true },
    taskPrimaryCheck: { checked: false, timestamp: null, user: null },

    taskDuality: { value: "", active: true },
    taskDualityCheck: { checked: false, timestamp: null, user: null },
    actions: {
      canAdd: true
    },
    allocationFields: {
      shortName: false,
      isin: false,
      corpRef: false,
      ack: false
    },
    Items: "",

    allocations: [
      {
        allocPrimary: { value: "", active: true },
        allocPrimaryCheck: { checked: false, timestamp: null, user: null },

        allocDuality: { value: "", active: true },
        allocDualityCheck: { checked: false, timestamp: null, user: null },

        shortName: { value: "", active: true },   
        isin:      { value: "", active: true },   
        corpRef:   { value: "", active: true },   
        ack:       { value: "", active: true }    
      }
    ],

    Comments: ""
  },
     {
    Time: "10:40",
    Task: "Send GS correction report for flubs",

    taskPrimary: { value: "", active: true },
    taskPrimaryCheck: { checked: false, timestamp: null, user: null },

    taskDuality: { value: "", active: true },
    taskDualityCheck: { checked: false, timestamp: null, user: null },
    actions: {
      canAdd: false
    },
    allocationFields: {
      shortName: false,
      isin: false,
      corpRef: false,
      ack: false
    },
    Items: "",

    allocations: [
      {
        allocPrimary: { value: "", active: true },
        allocPrimaryCheck: { checked: false, timestamp: null, user: null },

        allocDuality: { value: "", active: true },
        allocDualityCheck: { checked: false, timestamp: null, user: null },

        shortName: { value: "", active: true },   
        isin:      { value: "", active: true },   
        corpRef:   { value: "", active: true },   
        ack:       { value: "", active: true }    
      }
    ],

    Comments: ""
  },
     {
    Time: "11:15",
    Task: "Check new or updated upcoming dividend / capital distributions in CSD",

    taskPrimary: { value: "", active: true },
    taskPrimaryCheck: { checked: false, timestamp: null, user: null },

    taskDuality: { value: "", active: true },
    taskDualityCheck: { checked: false, timestamp: null, user: null },
    actions: {
      canAdd: true
    },
    allocationFields: {
      shortName: false,
      isin: false,
      corpRef: false,
      ack: false
    },
    Items: "",

    allocations: [
      {
        allocPrimary: { value: "", active: true },
        allocPrimaryCheck: { checked: false, timestamp: null, user: null },

        allocDuality: { value: "", active: true },
        allocDualityCheck: { checked: false, timestamp: null, user: null },

        shortName: { value: "", active: true },   
        isin:      { value: "", active: true },   
        corpRef:   { value: "", active: true },   
        ack:       { value: "", active: true }    
      }
    ],

    Comments: ""
  },
     {
    Time: "12:00",
    Task: "Check Forgein Currency cash account linkage from OB10. ! For Scooby-Doo please prepare electronically signed PDF with foreign currency AAA details for each KA account separatelly!",

    taskPrimary: { value: "", active: true },
    taskPrimaryCheck: { checked: false, timestamp: null, user: null },

    taskDuality: { value: "", active: true },
    taskDualityCheck: { checked: false, timestamp: null, user: null },
    actions: {
      canAdd: false
    },
    allocationFields: {
      shortName: false,
      isin: false,
      corpRef: false,
      ack: false
    },
    Items: "",

    allocations: [
      {
        allocPrimary: { value: "", active: true },
        allocPrimaryCheck: { checked: false, timestamp: null, user: null },

        allocDuality: { value: "", active: true },
        allocDualityCheck: { checked: false, timestamp: null, user: null },

        shortName: { value: "", active: true },   
        isin:      { value: "", active: true },   
        corpRef:   { value: "", active: true },   
        ack:       { value: "", active: true }    
      }
    ],

    Comments: ""
  },
     {
    Time: "12:40",
    Task: "Count KPI's for previous business day",

    taskPrimary: { value: "", active: true },
    taskPrimaryCheck: { checked: false, timestamp: null, user: null },

    taskDuality: { value: "", active: true },
    taskDualityCheck: { checked: false, timestamp: null, user: null },
    actions: {
      canAdd: false
    },
    allocationFields: {
      shortName: false,
      isin: false,
      corpRef: false,
      ack: false
    },
    Items: "",

    allocations: [
      {
        allocPrimary: { value: "", active: true },
        allocPrimaryCheck: { checked: false, timestamp: null, user: null },

        allocDuality: { value: "", active: true },
        allocDualityCheck: { checked: false, timestamp: null, user: null },

        shortName: { value: "", active: true },   
        isin:      { value: "", active: true },   
        corpRef:   { value: "", active: true },   
        ack:       { value: "", active: true }    
      }
    ],

    Comments: ""
  },
     {
    Time: "14:00",
    Task: "Process PINK events from colorful list (Manual msg)",

    taskPrimary: { value: "", active: true },
    taskPrimaryCheck: { checked: false, timestamp: null, user: null },

    taskDuality: { value: "", active: true },
    taskDualityCheck: { checked: false, timestamp: null, user: null },
    actions: {
      canAdd: true
    },
    allocationFields: {
      shortName: false,
      isin: false,
      corpRef: false,
      ack: false
    },
    Items: "",

    allocations: [
      {
        allocPrimary: { value: "", active: true },
        allocPrimaryCheck: { checked: false, timestamp: null, user: null },

        allocDuality: { value: "", active: true },
        allocDualityCheck: { checked: false, timestamp: null, user: null },

        shortName: { value: "", active: true },   
        isin:      { value: "", active: true },   
        corpRef:   { value: "", active: true },   
        ack:       { value: "", active: true }    
      }
    ],

    Comments: ""
  },
];
